import { Period } from "./fetchAndBuildCurrencyExchangeRatesData";
export function getPercentageDifferenceForPeriod(currencyExchangeRateData, instrumentIso, period, direct) {
    const direction = direct ? 'direct' : 'reverse';
    const latestRate = currencyExchangeRateData[Period.latest]?.[instrumentIso][direction];
    const periodRate = currencyExchangeRateData[period]?.[instrumentIso][direction];
    if (!periodRate || !latestRate)
        return null;
    const difference = ((latestRate - periodRate) / periodRate) * 100;
    return difference;
}
